export default __webpack_public_path__ + "static/jonny1-de09b3db60fe7cac7f740a41447d6df0.jpg";